import moment from 'moment';
import HttpFactory from '@/mixins/http.factory';
import TagsInput from '@/components/Inputs/TagsInput'
import { Select, Option } from 'element-ui'
import HtmlEditor from '@/components/Inputs/HtmlEditor'

export default {
	mixins:[HttpFactory],
	data () {
		return {
			htmlMessage:null,
			data:null,
			asanaWorkspaceData:{
                workspaceList:[],
                projectsList:[],
				usersList:[],
				tagsList:[],
				org_customFields:[],
				customFields:[]

				
            },
			showTags:false,
            editor_description_Obj:null,
            createTaskData:{attachments:[],files:[],task:{followers:[],tags:[]}},
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			let _self=this;
			modalClient = ZAFClient.init();
			parentClient=null;
			var count=0;
			modalClient.on('send_data_to_modal', (data) => {
				parentClient = modalClient.instance(data.parentClientGuid)
				_self.zendeskInfo=data;
				count++;
				if(count==1){
					_self.TaskFields();
				}
			});
		},
		initDropzone(data){
			const _self=this;
			if(!data || !data.userInfo || !data.userInfo.uploadFiles)return;
			_self.fn().initDropzone('div.dropzone',data.credentials,'asana',function(error,response){
				if(error){
					return;
				}
				_self.createTaskData.files=_self.createTaskData.files.concat(response);
			});
		},
		removeFile(file){
			const _self=this;
			_self.createTaskData.files=_self.createTaskData.files.filter(d=>d.id!=file.id);
		},
		initcreateTaskData(data,workspace){
			let _self=this;
			_self.createTaskData.task={followers:[],tags:[]};

			let comments=_self.zendeskInfo.ticket.comments;
			if(comments){
				let description_html=comments && comments.length>0?comments[comments.length-1].value:_self.zendeskInfo.ticket.description;
				let description_text=_self.zendeskInfo.ticket.description;
				_self.createTaskData.task.notes=description_text;
			}

			_self.createTaskData.hdTicketId=data.hdTicketId?data.hdTicketId:data.ticket.id;
			_self.createTaskData.task['name']=data.ticket.subject;
			//console.log('zendesk info',data);
			_self.createTaskData.task['assignee']='';
			_self.createTaskData.task['labels']=[];
			_self.showTags=true;

			_self.createTaskData.task['workspace']= workspace?workspace.gid:'';
			_self.createTaskData.task['project']='';
			
			_self.createTaskData.task.custom_fields={};
			//boolean

		},
		TaskFields(){
			let _self=this;
			_self.asanaWorkspacesFn(async function(workspaceResp){
				let workspaceList=workspaceResp.data.Data;
				_self.htmlMessage=workspaceResp.data.htmlMessage;
				
				if(workspaceList && workspaceList.length>0){
					_self.asanaWorkspaceData.workspaceList=workspaceList;
					_self.initcreateTaskData(_self.zendeskInfo,workspaceList[0]);
					_self.fn().showLoader(true);
					
					await _self.asanaWorkspaceDataList();
					//_self.fn().showLoader(false);
					//setTimeout(function(){_self.initDropzone(_self.zendeskInfo);},500);
					setTimeout(function(){
						let comments=_self.zendeskInfo.ticket.comments;
						if(comments){
							//let description_html=comments && comments.length>0?comments[comments.length-1].value:_self.zendeskInfo.ticket.description;
							// _self.fn().createHtmlEditor('editor_description','editor_description',description_html,function(editorObj,error){
							// 	_self.editor_description_Obj=editorObj?editorObj:null;
							// });
							let description_text=_self.zendeskInfo.ticket.description;
							//_self.createTaskData.task.html_notes=description_text;
							//_self.createTaskData.task.notes=description_text;
						}
					},1000);
				}
				
			},function(err){
				_self.fn().showLoader(false);
				let erroList=[
					'We see your authentication token for the Asana does not have required permissions.',
					'Can you please create Asana token as per below article and update the app.',
					'https://support.devopsintegration.io/support/solutions/articles/82000555961-how-to-create-asana-authentication-token-'
				]
				_self.userMsg={show:true,type:'danger',list:erroList};
			});
		},
		asanaWorkspaceDataList:async function(){
			const _self=this;
			let workspace=_self.createTaskData.task.workspace;
			_self.asanaWorkspaceDataFn(workspace,async function(dataResp){
				_self.fn().showLoader(false);
				_self.asanaWorkspaceData.usersList= dataResp.data.Data.usersList;
				_self.asanaWorkspaceData.projectsList= dataResp.data.Data.projectsList;
				_self.asanaWorkspaceData.tagsList= dataResp.data.Data.tagsList;
				//_self.asanaWorkspaceData.customFields= dataResp.data.Data.customFields;
				//_self.asanaWorkspaceData.org_customFields= dataResp.data.Data.customFields;
				//_self.initFieldsDefaultVal(_self.asanaWorkspaceData.customFields);

				if(_self.asanaWorkspaceData.projectsList.length>0){
					let project=_self.asanaWorkspaceData.projectsList[0];
					_self.createTaskData.task.project=project.gid;
					await _self.asanaProjectDataList();
				}else{
					_self.fn().showLoader(false);
				}
			},function(err){
				_self.fn().showLoader(false);
				let erroList=[
					'We see your authentication token for the Asana does not have required permissions.',
					'Can you please create Asana token as per below article and update the app.',
					'https://support.devopsintegration.io/support/solutions/articles/82000555961-how-to-create-asana-authentication-token-'
				]
				_self.userMsg={show:true,type:'danger',list:erroList};
			});
		},
		asanaProjectDataList:async function(){
			const _self=this;
			let project=_self.createTaskData.task.project;
			if(!project){
				_self.asanaWorkspaceData.customFields=_self.asanaWorkspaceData.org_customFields;
				_self.initFieldsDefaultVal(_self.asanaWorkspaceData.customFields)
				return;
			}
			_self.asanaProjectDataFn(project,function(dataResp){
				_self.fn().showLoader(false);
				//_self.asanaWorkspaceData.customFields=_self.asanaWorkspaceData.org_customFields.concat(dataResp.data.Data.customFields);
				_self.asanaWorkspaceData.customFields=dataResp.data.Data.customFields;
				_self.initFieldsDefaultVal(_self.asanaWorkspaceData.customFields)
			},function(err){
				_self.fn().showLoader(false);
				let erroList=[
					'We see your authentication token for the Asana does not have required permissions.',
					'Can you please create Asana token as per below article and update the app.',
					'https://support.devopsintegration.io/support/solutions/articles/82000555961-how-to-create-asana-authentication-token-'
				]
				_self.userMsg={show:true,type:'danger',list:erroList};
			});
		},
		initFieldsDefaultVal(fieldsList){
			const _self=this;
			let pickListFields=fieldsList.filter(d=>d.type=='enum');
			_self.createTaskData.task.custom_fields={};
			for(var i=0;i<pickListFields.length;i++){
				_self.createTaskData.task.custom_fields[pickListFields[i].gid]=_self.createTaskData.task.custom_fields[pickListFields[i].gid]?_self.createTaskData.task.custom_fields[pickListFields[i].gid]:'';
			}
		},
		async validateForm(){
			let isValid=await this.$validator.validateAll();
			
			if(!isValid){
				this.userMsg={show:true,type:'danger',list:[`Please scroll up and fill all required fields.`]}
			}
			return isValid;
		},
		onDateChanged(date,el) {
			let _self = this;
			let referenceName=el.target.getAttribute('referenceName');
			_self.createTaskData.task[referenceName]=date?_self.apiDateValue(date):null;
		},
		formatDateValue(date){
			if(!date) return null;
			return moment(date).format('YYYY-MM-DD');
		},
		apiDateValue(dateObj){
			let _self=this;
			let date=_self.formatDateValue(dateObj);
			return date;
			// if(!date) return null;
			
			// var currentDate = new Date();
			// var newDate= (new Date(`${date} `+currentDate.toLocaleTimeString()));
			// newDate.setMinutes(newDate.getMinutes()+(currentDate.getTimezoneOffset()*-1));
			// return newDate.toISOString();
			
		},
		//create init
		asanaWorkspacesFn:function(successCb,errorCb){
            var _self=this;
            var url = `asana/workspaces`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
        },
		asanaWorkspaceDataFn:function(workspace,successCb,errorCb){
            var _self=this;
            var url = `asana/workspace/${workspace}`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
        },
		asanaProjectDataFn:function(project,successCb,errorCb){
            var _self=this;
            var url = `asana/project/${project}`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
        },
        createTaskFn(){
			let _self=this;
			_self.fn().clearMessage();
		
			if(_self.editor_description_Obj)
				_self.createTaskData.task['html_notes']=_self.fn().getHtmlEditorContent(_self.editor_description_Obj);
			
			let data=JSON.parse(JSON.stringify(_self.createTaskData));
			if(data.task.start_on && !data.task.due_on){
				_self.userMsg={show:true,type:'danger',list:[`Please enter Due date.`]}
				return;
			}
			
			if(new Date(data.task.start_on)> new Date(data.task.due_on)){
				_self.userMsg={show:true,type:'danger',list:[`Start date must be before Due date.`]}
				return;
			}
			//data.task.followers=data.task.followers.map(d=>d.gid);
			//data.task.tags=data.task.tags.map(d=>d.gid);
			data.task.projects=data.task.project?data.task.project.split(','):[];
			delete data.task.project;
			data.auth=_self.zendeskInfo.credentials;
			data.user=_self.zendeskInfo.user;
			let url=`asana/tasks/create`;
			_self.postServerFn(url,data,function(response){
				_self.fn().showLoader(false);
				let userMsg;
				if(response.data.Success){
					userMsg={show:true,type:'info',list:[response.data.Data?response.data.Data:`Task created Successfully`]}
					_self.sendDataToParent(response.data);
				}else{
					userMsg={show:true,type:'danger',list:[response.data.Data?response.data.Data:`Task creation failed.`]}
				}
				_self.userMsg=userMsg;
			},function(error){ 
				_self.fn().showLoader(false);
				_self.commonErrorMsgDisp(error);
			});
		},
		closeDialog(){
			modalClient.invoke('destroy');
		},
		htmlEditorChange(data){
			const _self=this;
			_self.createItemData.fields[data.referenceName]=data.htmlContent?data.htmlContent:null;
		},
		sendDataToParent(data){
			parentClient.trigger('receive_data_from_modal', data)
      		modalClient.invoke('destroy');

		},
		postServerFn(url,data,successCb,errorCb){
			let _self=this;
			data=data?data:{};
			data.auth=_self.zendeskInfo.credentials;
			_self.post(url,data).then(response=>{
				if(successCb) successCb(response);
			}).catch(error=>{
				if(errorCb) errorCb(error);
			});
		}
	},
	components:{HtmlEditor,TagsInput,[Select.name]: Select,[Option.name]: Option}
}

